import ExternalSociety from "./ExternalSociety";
import UserProfile from "./UserProfile";
import { ROLES } from "@/utils/users";

export default class ProjectRole {
  constructor(projectRole) {
    this.setData(projectRole);
  }

  setData(projectRole) {
    if (!projectRole) {
      projectRole = {};
    }
    this.user_profile = new UserProfile(projectRole.user_profile);
    this.external_society = new ExternalSociety(projectRole.external_society);

    delete projectRole["user_profile"];
    delete projectRole["external_society"];

    const defaultValue = {
      uuid: null,
      role: null,
      project_phone_number: "",
      project_contributor_first_name: "",
      project_contributor_last_name: "",
      mandatory_recipient: false,
      external_role: null,
      project_hierarchical_role: null,
    };

    const well_formated_data = { ...defaultValue, ...projectRole };

    for (let [key, value] of Object.entries(well_formated_data)) {
      this[key] = value;
    }
  }

  getProjectRole() {
    // setProjectInformations is user is dev so we need to double check here
    if (this.isDevOrSuperUser()) {
      return ROLES.DEVELOPER;
    } else {
      return this.role;
    }
  }

  getDisplayName() {
    // is external implicitly (if is from Socotec, project_contributor_first_name is not defined)
    if (
      this.project_contributor_first_name ||
      this.project_contributor_last_name
    ) {
      return `${this.project_contributor_first_name} ${this.project_contributor_last_name}`;
    }
    if (this.user_profile.first_name) {
      return `${this.user_profile.first_name} ${this.user_profile.last_name}`;
    }

    return this.user_profile.email;
  }

  getDisplayInitials() {
    try {
      const firstName =
        this.project_contributor_first_name || this.user_profile.first_name;
      const lastName =
        this.project_contributor_last_name || this.user_profile.last_name;
      return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
    } catch {
      return this.user_profile.email.charAt(0).toUpperCase();
    }
  }
}
